import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setDataOnLocalStorage } from "../util/localStorage";
import useApi from "../hooks/useApi";
import { baseUrl } from "../config/apiConfig";
import AI_PDF_CONST from "../util/PdfAiConst";

const CredentialsLoginComponent = () => {
  const { callApi, loading } = useApi();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    try {
      const data = await callApi(
        `${baseUrl + AI_PDF_CONST.API_ENDPOINT.LOGIN}`,
        "POST",
        { source: "credentials", email, password }
      );

      // Backend returns HTTP 200 even on failure — guard before accessing data.data
      if (!data || data.status !== 200 || !data.data) {
        setErrorMessage(data?.message || "Invalid credentials. Please try again.");
        return;
      }

      setDataOnLocalStorage("token", data.data.access_token);

      const userObj = {
        auth_id: data.data.auth_id,
        auth_source: data.data.auth_source,
        email: data.data.email,
        id: data.data.id,
        name: data.data.name,
        userProfileImg: "",
        org_id: data.data.org_id,
        role: data.data.role,
      };
      setDataOnLocalStorage("userInfo", userObj);

      navigate("/home");
    } catch (err) {
      setErrorMessage(err.message || "Invalid credentials. Please try again.");
    }
  };

  return (
    <div className="w-full">
      <form onSubmit={handleLogin} className="space-y-4">
        <div>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => { setEmail(e.target.value); setErrorMessage(""); }}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            placeholder="Email address"
          />
        </div>
        <div>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => { setPassword(e.target.value); setErrorMessage(""); }}
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-all"
            placeholder="Password"
          />
        </div>

        {/* inline error banner */}
        {errorMessage && (
          <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600">
            <svg className="w-4 h-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            {errorMessage}
          </div>
        )}

        {loading ? (
          <div className="flex justify-center py-3">
            <div className="dot-pulse" style={{ backgroundColor: '#4f46e5' }}></div>
          </div>
        ) : (
          <button
            type="submit"
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-medium py-3 px-4 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#1e2532] focus:ring-indigo-500 shadow-lg"
          >
            Sign In
          </button>
        )}
      </form>
    </div>
  );
};

export default CredentialsLoginComponent;
